module.exports = __webpack_public_path__ + "static/about_mozliwosci-1e54d6125602a6644c65c81bffac4710.jpg";